<template>
  <div style="min-height: 100px" v-loading="!pageData && loading">
    <div v-if="pageData">
      <el-table
        lazy
        ref="table"
        :data="pageData"
        :load="loadChildren"
        :show-header="false"
        :cell-class-name="activeClass"
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        @current-change="handleClick"
        @expand-change="handleExpandChange"
        row-key="guid"
      >
        <el-table-column prop="classifyName" label="分类名称" min-width="180">
          <template slot-scope="scope">
            {{ scope.row.classifyName }}
            <span v-if="scope.row.goodsCount >= 0">
              ({{ scope.row.goodsCount }})
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-empty v-else-if="!loading" :description="errorMsg" :image-size="100">
      <el-button v-if="errorMsg" @click="refreshList" size="small">
        重新加载
      </el-button>
    </el-empty>
  </div>
</template>

<style lang="less" >
.active-class {
  background: #f1f1f1;
}
</style>

<script>
export default {
  props: {
    params: {
      type: Object,
      default: () => {
        return {};
      },
    },
    query: {
      type: Object,
      default: () => {
        return {};
      },
    },
    storeGuid: {
      type: String,
    },
    value: {
      type: String
    },
  },
  computed: {
    pageParams() {
      return Object.assign({},
        (this.$route && this.$route.params) || {},
        this.params
      );
    },
    pageQuery() {
      return Object.assign({},
        (this.$route && this.$route.query) || {},
        this.query
      );
    },
  },
  data() {
    return {
      loading: false,
      errorMsg: null,
      pageData: null,
      currentParentGuid: null,
      tableTreeRefreshTool: {}
    };
  },
  model: {
    prop: "value",
    event: "change"
  },
  methods: {
    activeClass({ row, column, rowIndex, columnIndex }) {
      if (row.guid == this.value) return "active-class";
    },
    handleClick(currentRow) {
      this.$emit("change", currentRow && currentRow.guid || '');
    },
    loadChildren(tree, treeNode, resolve) {
      this.currentParentGuid = tree.guid
      this.tableTreeRefreshTool[tree.guid] = {}
      this.tableTreeRefreshTool[tree.guid].resolve = resolve;
      this.tableTreeRefreshTool[tree.guid].expandCount = 0;
      this.requestApi("biz.goods.classify.info.listByStore", {
        parentGuid: tree.guid,
        storeGuid: this.storeGuid
      }, {
        cache: 1, cacheCallback: (resp) => {
          resolve((resp.data.list || []).map(item => {
            return Object.assign({
              hasChildren: item.childrenCount > 0,
            }, item)
          }));
        }
      }).then((resp) => {
        resolve((resp.data.list || []).map(item => {
          return Object.assign({
            hasChildren: item.childrenCount > 0,
          }, item)
        }));
      }).catch((err) => {
        resolve([]);
      });
    },
    handleExpandChange(tree, expanded) {
      const curr = this.tableTreeRefreshTool[tree.guid]
      curr.expandCount++
      curr.prevStatus = expanded;
      this.refreshChildrenList(tree.guid);
    },
    handleFetchChildrenResp(resp) {
      Promise.resolve(resp).then((resp) => {
        return resp.data.list || [];
      }).catch((err) => {
        return [];
      }).then((resp) => {
        this.$set(this.$refs.table.store.states.lazyTreeNodeMap,
          parentGuid, resp.map(item => {
            return Object.assign({
              hasChildren: item.childrenCount > 0,
            }, item)
          }))
      });
    },
    refreshChildrenList(parentGuid) {
      const curr = this.tableTreeRefreshTool[parentGuid]
      if (curr && curr.prevStatus) {
        this.requestApi("biz.goods.classify.info.listByStore", {
          parentGuid,
          storeGuid: this.storeGuid
        }, {
          cache: 1, cacheCallback: (resp) => {
            this.handleFetchChildrenResp(resp);
          }
        }).then((resp) => {
          this.handleFetchChildrenResp(resp);
        })
      }
    },
    handleFetchResp(resp) {
      this.pageData = (resp.data.list || []).map(item => {
        return Object.assign({ hasChildren: item.childrenCount > 0 }, item)
      });
      this.pageData.unshift({
        guid: "",
        classifyName: "全部商品",
        goodsCount: -1
      });
    },
    refreshList() {
      this.errorMsg = null;
      this.loading = true;
      return this.requestApi("biz.goods.classify.info.listByStore", {
        storeGuid: this.storeGuid
      }, {
        cache: 1, cacheCallback: (resp) => {
          this.handleFetchResp(resp);
        }
      }).then((resp) => {
        this.loading = false;
        this.handleFetchResp(resp);
      }).catch((err) => {
        this.loading = false;
        this.errorMsg = (err && (err.msg || err.message))
          || "连接服务器失败，请检查网络";
      });
    },
    refreshByRow(parentGuid) {
      this.refreshTool();
      this.refreshChildrenList(parentGuid);
      this.refreshList();
    },
    refreshTool() {
      (this.pageData || []).forEach(item => {
        if (!item.hasChildren) {
          this.tableTreeRefreshTool[item.guid] = undefined;
          delete this.tableTreeRefreshTool[item.guid];
        }
      });
    },
  },
  mounted() {
    this.refreshList();
  },
};
</script>